import { useEffect } from 'react';
import { captureUtmParams } from '../lib/utmContext';

/** Saves first-touch UTM from landing URL into sessionStorage for SPA navigation. */
export default function UtmCapture() {
  useEffect(() => {
    captureUtmParams();
  }, []);
  return null;
}
